import { Controllers } from "@infoland/iprova-api";
import { PortalInformation } from "@/types/portal/index";

// state type
export interface PortalInformationState {
    currentPortalInformation: PortalInformation;
}

export function initialize(): PortalInformationState {
    return {
        currentPortalInformation: null
    };
}

// initial state
const state: PortalInformationState = initialize();

// getters for this store
const getters = {
    /**
     * The the current portal
     * @param state The state to read from
     */
    currentPortalInformation(state: PortalInformationState): PortalInformation {
        return state.currentPortalInformation;
    }
};

// mutations for this store
const mutations = {
    /**
     * Set the portal id
     * @param state The state to write to
     * @param portalInformation  the portal information
     */
    _currentPortalInformation(state: PortalInformationState, portalInformation: PortalInformation): void {
        // undefined should become null
        if (!portalInformation) portalInformation = null;

        state.currentPortalInformation = portalInformation;
    }
};

// actions for this store
const actions = {
    /**
     * loads the portal information
     * @param context The context of the action
     * @param portalId The id of the portal
     */
    async loadPortalInformation(context: { commit: (path: string, value: PortalInformation) => void }, portalId: number): Promise<PortalInformation> {
        // load portal information
        const portalInformation = await Controllers.GenericController.getAsync<PortalInformation>(`/portals/${portalId}/information`);
        context.commit("_currentPortalInformation", portalInformation);
        return portalInformation;
    }
};

// export the namespace
export const namespace = "portalInformation";

// export the store 'module'
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
